(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avis-defilants"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('solavia-review-band')) {
    class SolaviaReviewBand extends HTMLElement {
      connectedCallback() {
        if (this.active) return;
        this.active = true;
        this.rows = [...this.querySelectorAll('[data-review-row]')];
        this.pauseButton = this.querySelector('[data-review-pause]');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onResize = () => this.scheduleRefresh();
        this.onPause = () => {
          const paused = !this.hasAttribute('data-paused');
          this.toggleAttribute('data-paused', paused);
          this.pauseButton.setAttribute('aria-pressed', String(paused));
          const label = paused ? 'Reprendre le défilement' : 'Mettre le défilement en pause';
          this.pauseButton.setAttribute('aria-label', label);
          this.pauseButton.title = label;
        };
        this.onBlockSelect = (event) => {
          const blockId = event.detail?.blockId;
          const item = [...this.querySelectorAll('[data-review-block-id]')].find(node => node.dataset.reviewBlockId === blockId);
          if (!item) return;
          this.setAttribute('data-editor-paused', '');
          const row = item.closest('[data-review-row]');
          const sequence = row.querySelector('[data-review-sequence="original"]');
          const left = item.getBoundingClientRect().left - sequence.getBoundingClientRect().left;
          row.style.setProperty('--avd-editor-offset', `${32 - left}px`);
          row.setAttribute('data-editor-focused', '');
        };
        this.onBlockDeselect = () => {
          this.removeAttribute('data-editor-paused');
          this.rows.forEach(row => row.removeAttribute('data-editor-focused'));
        };
        this.pauseButton?.addEventListener('click', this.onPause);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.motionQuery.addEventListener('change', this.onResize);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            const width = this.getBoundingClientRect().width;
            if (width === this.lastWidth) return;
            this.lastWidth = width;
            this.scheduleRefresh();
          });
          this.resizeObserver.observe(this);
        } else {
          window.addEventListener('resize', this.onResize, { passive: true });
        }
        this.scheduleRefresh();
        document.fonts?.ready.then(() => { if (this.active) this.scheduleRefresh(); });
      }

      scheduleRefresh() {
        if (!this.active) return;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.refresh());
      }

      makeCopy(node) {
        const copy = node.cloneNode(true);
        copy.setAttribute('data-review-clone', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.inert = true;
        [copy, ...copy.querySelectorAll('*')].forEach(element => {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
          element.removeAttribute('data-review-block-id');
          element.removeAttribute('data-review-group');
          element.removeAttribute('data-review-sequence');
        });
        return copy;
      }

      refresh() {
        const speed = Math.max(10, Math.min(70, Number(this.dataset.speed) || 40));
        const reduced = this.motionQuery.matches;
        this.rows.forEach(row => {
          const track = row.querySelector('.avd__track');
          const group = row.querySelector('[data-review-group="original"]');
          const sequence = group?.querySelector('[data-review-sequence="original"]');
          if (!sequence) return;
          row.removeAttribute('data-ready');
          track.querySelectorAll('[data-review-clone]').forEach(copy => copy.remove());
          if (reduced) return;
          const unitWidth = sequence.getBoundingClientRect().width;
          const viewportWidth = row.getBoundingClientRect().width;
          if (!unitWidth || !viewportWidth) return;
          const copies = Math.max(1, Math.ceil((viewportWidth + 1) / unitWidth));
          for (let i = 1; i < copies; i++) group.append(this.makeCopy(sequence));
          const groupWidth = group.getBoundingClientRect().width;
          if (!groupWidth) return;
          track.append(this.makeCopy(group));
          const duration = groupWidth / speed;
          row.style.setProperty('--avd-duration', `${duration}s`);
          row.style.setProperty('--avd-delay', `${-duration * .2}s`);
          row.setAttribute('data-ready', '');
        });
        if (this.pauseButton) this.pauseButton.hidden = reduced || !this.rows.some(row => row.hasAttribute('data-ready'));
      }

      disconnectedCallback() {
        this.active = false;
        cancelAnimationFrame(this.frame);
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.onResize);
        this.motionQuery?.removeEventListener('change', this.onResize);
        this.pauseButton?.removeEventListener('click', this.onPause);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    }
    customElements.define('solavia-review-band', SolaviaReviewBand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('solavia-faq')) {
    class SolaviaFaq extends HTMLElement {
      connectedCallback() {
        if (this.active) return;
        this.active = true;
        this.onToggle = (event) => {
          const item = event.target;
          if (this.dataset.singleOpen !== 'true' || !item.matches?.('.sfa__item') || !item.open) return;
          this.querySelectorAll('.sfa__item[open]').forEach((other) => {
            if (other !== item) other.open = false;
          });
        };
        this.onBlockSelect = (event) => {
          const item = Array.from(this.querySelectorAll('.sfa__item')).find((node) => node.dataset.faqId === event.detail?.blockId);
          if (item) item.open = true;
        };
        this.addEventListener('toggle', this.onToggle, true);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        this.removeEventListener('toggle', this.onToggle, true);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.active = false;
      }
    }
    customElements.define('solavia-faq', SolaviaFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mur-clients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('solavia-photo-wall')) {
    class SolaviaPhotoWall extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.start());
      }

      start() {
        if (!this.isConnected || this.active) return;
        this.source = this.querySelector('.svw__source');
        this.grid = this.querySelector('.svw__grid');
        this.windowElement = this.querySelector('.svw__window');
        this.pauseButton = this.querySelector('.svw__pause');
        if (!this.source || !this.grid || !this.windowElement) return;
        this.items = Array.from(this.source.children);
        if (!this.items.length) return;
        this.active = true;
        this.editorSelected = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onMotion = () => this.layout(true);
        this.onPause = () => {
          this.toggleAttribute('data-paused');
          this.updatePauseButton();
        };
        this.onSelect = (event) => {
          const item = this.items.find((node) => node.dataset.photoId === event.detail?.blockId);
          if (!item) return;
          this.editorSelected = true;
          this.layout(true);
          item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        };
        this.onDeselect = (event) => {
          if (!this.items.some((node) => node.dataset.photoId === event.detail?.blockId)) return;
          this.editorSelected = false;
          this.layout(true);
        };
        this.pauseButton?.addEventListener('click', this.onPause);
        this.addEventListener('shopify:block:select', this.onSelect);
        this.addEventListener('shopify:block:deselect', this.onDeselect);
        this.motion.addEventListener('change', this.onMotion);
        this.resizeObserver = new ResizeObserver(() => {
          cancelAnimationFrame(this.layoutFrame);
          this.layoutFrame = requestAnimationFrame(() => this.layout());
        });
        this.resizeObserver.observe(this.windowElement);
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver((entries) => {
            this.toggleAttribute('data-offscreen', !entries[0].isIntersecting);
          }, { rootMargin: '100px' });
          this.visibilityObserver.observe(this);
        }
        this.layout(true);
      }

      restoreOriginals() {
        this.items.forEach((item) => this.source.appendChild(item));
        this.grid.replaceChildren();
        this.grid.hidden = true;
        this.source.hidden = false;
        this.removeAttribute('data-ready');
      }

      cloneForLoop(node) {
        const copy = node.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.dataset.loopCopy = '';
        const nodes = [copy, ...copy.querySelectorAll('[id], [data-photo-id], [data-shopify-editor-block]')];
        nodes.forEach((element) => {
          element.removeAttribute('id');
          element.removeAttribute('data-photo-id');
          element.removeAttribute('data-shopify-editor-block');
        });
        return copy;
      }

      layout(force = false) {
        if (!this.active || !this.isConnected) return;
        const bounds = this.windowElement.getBoundingClientRect();
        if (!bounds.width || !bounds.height) return;
        const requested = parseInt(getComputedStyle(this).getPropertyValue('--svw-requested-columns'), 10) || 2;
        const count = Math.min(requested, this.items.length);
        const isStatic = this.motion.matches || this.editorSelected;
        const signature = `${bounds.width}|${bounds.height}|${count}|${isStatic}|${this.dataset.speed}`;
        if (!force && this.signature === signature) return;
        this.signature = signature;
        this.restoreOriginals();
        this.style.setProperty('--svw-effective-columns', count);
        this.toggleAttribute('data-static', isStatic);
        if (isStatic) {
          if (this.pauseButton) this.pauseButton.hidden = true;
          return;
        }
        this.source.hidden = true;
        this.grid.hidden = false;
        const baseSpeed = Math.max(10, Number(this.dataset.speed) || 45);
        for (let index = 0; index < count; index += 1) {
          const column = document.createElement('div');
          const track = document.createElement('div');
          const group = document.createElement('div');
          const sequence = document.createElement('div');
          column.className = 'svw__column';
          track.className = 'svw__track';
          group.className = 'svw__group';
          sequence.className = 'svw__sequence';
          [column, track, group, sequence].forEach((node) => node.setAttribute('role', 'presentation'));
          this.items.forEach((item, itemIndex) => {
            if (itemIndex % count === index) sequence.appendChild(item);
          });
          group.appendChild(sequence);
          track.appendChild(group);
          column.appendChild(track);
          this.grid.appendChild(column);
          const sequenceHeight = sequence.getBoundingClientRect().height;
          if (!sequenceHeight) {
            this.restoreOriginals();
            if (this.pauseButton) this.pauseButton.hidden = true;
            this.signature = null;
            return;
          }
          const repetitions = Math.ceil(bounds.height / sequenceHeight);
          for (let repeat = 1; repeat < repetitions; repeat += 1) {
            group.appendChild(this.cloneForLoop(sequence));
          }
          const groupHeight = group.getBoundingClientRect().height;
          const speed = index % 2 ? baseSpeed * 0.68 : baseSpeed;
          column.style.setProperty('--svw-duration', `${groupHeight / speed}s`);
          column.style.setProperty('--svw-delay', `${-index * 2.8}s`);
          track.appendChild(this.cloneForLoop(group));
        }
        this.setAttribute('data-ready', '');
        if (this.pauseButton) this.pauseButton.hidden = false;
        this.updatePauseButton();
      }

      updatePauseButton() {
        if (!this.pauseButton) return;
        const paused = this.hasAttribute('data-paused');
        this.pauseButton.setAttribute('aria-pressed', String(paused));
        this.pauseButton.setAttribute('aria-label', paused ? 'Reprendre le défilement' : 'Mettre le défilement en pause');
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.layoutFrame);
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.motion?.removeEventListener('change', this.onMotion);
        this.pauseButton?.removeEventListener('click', this.onPause);
        this.removeEventListener('shopify:block:select', this.onSelect);
        this.removeEventListener('shopify:block:deselect', this.onDeselect);
        if (this.active) this.restoreOriginals();
        this.active = false;
        this.signature = null;
      }
    }
    customElements.define('solavia-photo-wall', SolaviaPhotoWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('solavia-testimonial-marquee')) {
    class SolaviaTestimonialMarquee extends HTMLElement {
      connectedCallback() {
        if (this.active) return;
        this.active = true;
        this.rows = Array.from(this.querySelectorAll('[data-review-row]'));
        this.pauseButton = this.querySelector('[data-review-pause]');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onResize = () => this.scheduleRefresh();
        this.onPause = () => {
          this.toggleAttribute('data-paused');
          this.updatePauseButton();
        };
        this.onBlockSelect = (event) => {
          const item = Array.from(this.querySelectorAll('[data-review-block-id]')).find(node => node.dataset.reviewBlockId === event.detail?.blockId);
          if (!item) return;
          this.setAttribute('data-editor-paused', '');
          const row = item.closest('[data-review-row]');
          const sequence = row.querySelector('[data-review-sequence="original"]');
          const left = item.getBoundingClientRect().left - sequence.getBoundingClientRect().left;
          row.style.setProperty('--stc-editor-offset', `${24 - left}px`);
          row.setAttribute('data-editor-focused', '');
        };
        this.onBlockDeselect = () => {
          this.removeAttribute('data-editor-paused');
          this.rows.forEach(row => row.removeAttribute('data-editor-focused'));
        };
        this.pauseButton?.addEventListener('click', this.onPause);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.motionQuery.addEventListener('change', this.onResize);
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.getBoundingClientRect().width;
          if (width === this.lastWidth) return;
          this.lastWidth = width;
          this.scheduleRefresh();
        });
        this.resizeObserver.observe(this);
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            this.toggleAttribute('data-offscreen', !entries[0].isIntersecting);
          }, { rootMargin: '100px' });
          this.visibilityObserver.observe(this);
        }
        this.scheduleRefresh();
        document.fonts?.ready.then(() => { if (this.active) this.scheduleRefresh(); });
      }
      scheduleRefresh() {
        if (!this.active) return;
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.refresh());
      }
      makeCopy(node) {
        const copy = node.cloneNode(true);
        copy.setAttribute('data-review-clone', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        [copy, ...copy.querySelectorAll('*')].forEach(element => {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
          element.removeAttribute('data-review-block-id');
          element.removeAttribute('data-review-group');
          element.removeAttribute('data-review-sequence');
        });
        return copy;
      }
      refresh() {
        if (!this.active || !this.isConnected) return;
        const mobile = this.getBoundingClientRect().width <= 749;
        const reduced = this.motionQuery.matches;
        this.rows.forEach(row => {
          const bottom = row.dataset.direction === 'right';
          const requestedSpeed = Number(bottom
            ? (mobile ? this.dataset.bottomMobileSpeed : this.dataset.bottomSpeed)
            : (mobile ? this.dataset.mobileSpeed : this.dataset.speed));
          const fallbackSpeed = bottom ? (mobile ? 15 : 25) : (mobile ? 20 : 35);
          const speed = Math.max(10, Math.min(70, requestedSpeed || fallbackSpeed));
          const track = row.querySelector('.stc__track');
          const group = row.querySelector('[data-review-group="original"]');
          const sequence = group?.querySelector('[data-review-sequence="original"]');
          if (!sequence) return;
          row.removeAttribute('data-ready');
          track.querySelectorAll('[data-review-clone]').forEach(copy => copy.remove());
          if (reduced) return;
          const unitWidth = sequence.getBoundingClientRect().width;
          const viewportWidth = row.getBoundingClientRect().width;
          if (!unitWidth || !viewportWidth) return;
          const copies = Math.max(1, Math.ceil((viewportWidth + 1) / unitWidth));
          for (let index = 1; index < copies; index += 1) group.append(this.makeCopy(sequence));
          const groupWidth = group.getBoundingClientRect().width;
          if (!groupWidth) return;
          track.append(this.makeCopy(group));
          const duration = groupWidth / speed;
          const startingOffset = bottom ? sequence.querySelector('.stc__card').getBoundingClientRect().width / 2 : 0;
          row.style.setProperty('--stc-duration', `${duration}s`);
          row.style.setProperty('--stc-delay', `${-startingOffset / speed}s`);
          row.scrollLeft = 0;
          row.setAttribute('data-ready', '');
        });
        if (this.pauseButton) this.pauseButton.hidden = reduced || !this.rows.some(row => row.hasAttribute('data-ready'));
        this.updatePauseButton();
      }
      updatePauseButton() {
        if (!this.pauseButton) return;
        const paused = this.hasAttribute('data-paused');
        const label = paused ? 'Reprendre le défilement' : 'Mettre le défilement en pause';
        this.pauseButton.setAttribute('aria-pressed', String(paused));
        this.pauseButton.setAttribute('aria-label', label);
        this.pauseButton.title = label;
      }
      disconnectedCallback() {
        this.active = false;
        cancelAnimationFrame(this.frame);
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.motionQuery?.removeEventListener('change', this.onResize);
        this.pauseButton?.removeEventListener('click', this.onPause);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    }
    customElements.define('solavia-testimonial-marquee', SolaviaTestimonialMarquee);
  }

  } catch(e) { console.error(e); }
})();
})();
